import React from 'react';
import PermissionRoles from './PermissionRoles';
import TemplatesPermissions from './TemplatesPermissions';
import { Pivot, PivotItem } from '@fluentui/react';

export default class SettingsPanel extends React.Component
{
    
    render() {

        return (
            <div>
                <Pivot styles={pivotStyles}>
                    <PivotItem headerText='Permission Roles'>
                        <PermissionRoles />
                    </PivotItem>
                    <PivotItem headerText='Templates Permissions'>
                        <TemplatesPermissions />
                    </PivotItem>
                </Pivot>
                
            </div>
        );
    }
}

const pivotStyles = {
    root: {
        marginBottom: 20
    },
    linkContent: {
        fontSize: 16,
    }
}


// WEBPACK FOOTER //
// ./src/components/Settings/SettingsPanel.js